import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"

import Navbar from "./navbar"
import Footer from "./footer"
import "./layout.scss"
import Cart from "./cart"
import Announcement from "./announcement"
export const CartContext = React.createContext([]);


const Layout = ({ children }) => {
  const [cart, setCart] = useState([])
  useEffect(() => {
    try {
      const stored = localStorage.getItem('cart')
      if (stored) {
        const parsed = JSON.parse(stored)
        if (Array.isArray(parsed)) {
          setCart(parsed)
        }
      }
    } catch {
      localStorage.removeItem('cart')
    }
  }, [])
  const [_showCart, setShowCart] = useState(false)

  const addToCart = ({ productId, size, thick = '0', selectedSize, color = {}, type = 0, quantity = 1, checkout = false }) => {
    const addQty = Math.max(1, parseInt(quantity, 10) || 1)
    const existingIndex = cart.findIndex(res =>
      res.productId === productId &&
      res.size === size &&
      String(res.thick || '0') === String(thick || '0') &&
      JSON.stringify(res.selectedSize || []) === JSON.stringify(selectedSize || []) &&
      Number(res.type || 0) === Number(type || 0) &&
      JSON.stringify(res.color || {}) === JSON.stringify(color || {})
    )

    let updatedCart
    if (existingIndex >= 0) {
      updatedCart = cart.map((item, idx) => {
        if (idx === existingIndex) {
          return {
            ...item,
            quantity: (parseInt(item.quantity, 10) || 1) + addQty,
          }
        }
        return item
      })
    } else {
      updatedCart = [
        ...cart,
        {
          productId,
          size,
          thick: String(thick || '0'),
          selectedSize,
          color,
          quantity: addQty,
          type: Number(type || 0),
        },
      ]
    }

    setCart(updatedCart)
    try {
      localStorage.setItem('cart', JSON.stringify(updatedCart))
    } catch (e) {
      console.error('Failed to save cart to localStorage', e)
    }

    if (checkout) {
      navigate('/checkout')
    } else {
      setTimeout(() => {
        setShowCart(true)
      }, 100)
    }
  }

  const updateCart = ({ index, quantity }) => {
    const qty = parseInt(quantity, 10)
    let updatedCart
    if (qty > 0) {
      updatedCart = cart.map((item, i) => (i === index ? { ...item, quantity: qty } : item))
    } else {
      updatedCart = cart.filter((_, i) => i !== index)
    }
    setCart(updatedCart)
    try {
      localStorage.setItem('cart', JSON.stringify(updatedCart))
    } catch (e) {
      console.error('Failed to save cart to localStorage', e)
    }
  }

  const clearCart = () => {
    setCart([])
    try {
      localStorage.removeItem('cart')
    } catch (e) {
      console.error('Failed to clear cart', e)
    }
  }

  const showCart = () => {
    setShowCart(!_showCart)
  }

  return (
    <div className="container-fluid p-0">
      <Announcement />
      <CartContext.Provider value={{ cart, addToCart, showCart, updateCart, clearCart }}>
        <Navbar />
        <Cart _showCart={_showCart} updateCart={updateCart}></Cart>
        <main>
          {children}
        </main>
        <Footer></Footer>
        <a
          href="https://wa.me/+919744488388"
          className="floating-whatsapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <i className="bi bi-whatsapp"></i>
        </a>
      </CartContext.Provider>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
